import { useSelector } from 'react-redux'
import { getMyAffiliates, getUser } from 'store/selectors'
import { Loader } from '@crossfit/ui'
import { User } from 'types'
import ReviewInvitePage from 'pages/TeamManagement/ReviewInvite'
import * as localStorageService from 'services/cookies'
import { useAuth } from 'components/Auth'
import useAnalytics from 'hooks/useAnalytics'

export default function AppContainer({ children }) {
  const { login, unauthenticated } = useAuth()
  const user = useSelector(getUser) as User
  const affiliates = useSelector(getMyAffiliates)
  const accessToken = localStorageService.getAccessToken()
  const pathName = location.pathname
  const isLoading = !user || affiliates.isLoading

  useAnalytics()

  if (!accessToken && !pathName.includes('logout')) {
    login()
  }

  if (accessToken && unauthenticated) {
    login()
  }

  // NOTE: If we are still waiting for authentication show the loader so we don't erroneously show Ineligible or TOS Page
  if (isLoading) {
    return <Loader />
  }

  if (location.pathname.includes('staff/review')) {
    return <ReviewInvitePage />
  }

  return <>{children}</>
}
